import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Restaurantdashboard',
  tabs: {
    [Tab.OngoingOrders]: 'Nu bereiden',
    [Tab.FutureOrders]: 'Toekomstig',
    [Tab.CompleteOrders]: 'Voltooid',
  },
  buttons: {
    order_history: 'Bestelgeschiedenis',
  },
  feedback: {
    future_orders_alert: '⚠️ Nog niet bereiden – we laten je weten wanneer je kunt beginnen.',
  },
};
